import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import dayjs from 'dayjs';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { cellFormat } from '../../../../../../../../../../lib/designSystem/Table/cellFormat';
import {
  getDueWorkingDay,
  isAValidDate,
} from '../../../../../../../../../../lib/functions/dates';
import {
  showAlert,
  validatePermissions,
} from '../../../../../../../../../../lib/functions/utils';
import { AuthState } from '../../../../../../../../../../services/redux/authSlice';

export interface CollectionState {
  collectionManagementOptions: any[];
  companyId: number;
  createdAt: string;
  id: number;
  name: string;
  updatedAt: string;
}

export const OptionsGrid = (props: any) => {
  const {
    executiveId,
    documentHasExecutives,
    byStakeholder,
    document,
    checkFields,
    option,
    setOption,
    setExecutiveId,
    loading,
    executivesOptions,
    portfolioExecutiveId,
    setPortfolioExecutiveId,
    stateId,
    handleSelectState,
    stateOptions,
    isManager,
    completedCheckbox,
    setCompletedCheckbox,
    completedDate,
    dueDate,
    description,
    setDescription,
    contactMethod,
    disabled,
    completed,
    setDueDate,
    setCompletedDate,
    setContactMethod,
    options,
    possiblePaymentDate,
    setPossiblePaymentDate,
  } = props;
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const dispatch = useDispatch();

  const setUpPortfolioExecutiveId = () => {
    if (documentHasExecutives) {
      console.log(validatePermissions(user, 'have_subordinates'));
      if (!validatePermissions(user, 'have_subordinates')) {
        if (user) {
          setExecutiveId(user.id);
        }
      }
    }
  };

  const handleSetDate = (date: string) => {
    let dueDate = new Date(date);
    dueDate.setUTCHours(12, 0, 0, 0);
    if (!isAValidDate(dueDate)) {
      dueDate = getDueWorkingDay(dueDate);
      showAlert(
        dispatch,
        'warning',
        `Se seleccionó un día no hábil, la fecha de gestión será el día ${cellFormat(dueDate, 'date')}`,
      );
    }
    console.log(dueDate);
    const dueDateFormatted = dayjs(dueDate).format('YYYY-MM-DD');
    setDueDate(dueDateFormatted);
  };

  useEffect(() => {
    setUpPortfolioExecutiveId();
  }, []);

  return (
    <div>
      {executiveId == 0 ? (
        documentHasExecutives ? (
          <div>
            <Typography variant="body1">
              Asigna la gestión a un ejecutivo
            </Typography>
            <Grid container spacing={2} style={{ paddingTop: '12px' }}>
              <Grid item xs={12}>
                <TextField
                  error={checkFields && option === ''}
                  select
                  value={executiveId}
                  label="Ejecutivo gestión"
                  variant="outlined"
                  fullWidth
                  onChange={(e) =>
                    setExecutiveId(e.target.value as unknown as number)
                  }
                  disabled={loading}
                >
                  {executivesOptions.map((element: any) => {
                    return (
                      <MenuItem key={element.id} value={element.id}>
                        {`${element.name} (${element.email})`}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Grid>
            </Grid>
          </div>
        ) : isManager ? (
          <div>
            <Typography variant="body1">
              {`No hay ejecutivos con este ${
                byStakeholder ? 'deudor' : 'cliente'
              } en su cartera. Puedes asignar un ejecutivo a este documento asociando ${
                byStakeholder
                  ? `${document.stakeholderName}`
                  : `${document.businessName}`
              } a su cartera.`}
            </Typography>
            <Grid container spacing={2} style={{ paddingTop: '12px' }}>
              <Grid item xs={12}>
                <TextField
                  error={checkFields && option === ''}
                  select
                  value={portfolioExecutiveId}
                  label="Ejecutivo a asignar"
                  variant="outlined"
                  fullWidth
                  onChange={(e) =>
                    setPortfolioExecutiveId(e.target.value as unknown as number)
                  }
                  disabled={loading}
                >
                  {executivesOptions.map((element: any) => {
                    return (
                      <MenuItem key={element.id} value={element.id}>
                        {`${element.name} (${element.email})`}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Grid>
            </Grid>
          </div>
        ) : (
          <Typography variant="body1">
            {`No hay ejecutivos con este documento en su cartera. Solicita a un
      gerente que asigne un ejecutivo a ${
        byStakeholder
          ? `${document.stakeholderName}`
          : `${document.businessName}`
      }.`}
          </Typography>
        )
      ) : (
        <Grid container spacing={2} style={{ paddingTop: '12px' }}>
          <Grid item xs={6}>
            <TextField
              error={checkFields && option === ''}
              select
              value={executiveId}
              label="Ejecutivo gestión"
              variant="outlined"
              fullWidth
              onChange={(e) =>
                setExecutiveId(e.target.value as unknown as number)
              }
              disabled={loading}
            >
              {executivesOptions.map((element: any) => {
                return (
                  <MenuItem key={element.id} value={element.id}>
                    {`${element.name} (${element.email})`}
                  </MenuItem>
                );
              })}
            </TextField>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Método de contacto
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={contactMethod}
                onChange={(e) => setContactMethod(e.target.value)}
                disabled={disabled}
                label="Método de contacto"
              >
                {[
                  'Llamada',
                  'Correo',
                  'Whatsapp',
                  'Visita a terreno',
                  'Portal',
                ].map((element) => {
                  return (
                    <MenuItem key={element} value={element}>
                      {element}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <TextField
              error={checkFields && option === ''}
              select
              value={stateId}
              label="Estado gestión"
              variant="outlined"
              fullWidth
              onChange={(e) =>
                handleSelectState(e.target.value as unknown as number)
              }
              disabled={loading}
            >
              {stateOptions.map((element: CollectionState) => {
                return (
                  <MenuItem key={element.id} value={element.id}>
                    {element.name}
                  </MenuItem>
                );
              })}
            </TextField>
          </Grid>
          <Grid item xs={6}>
            <TextField
              error={checkFields && option === ''}
              select
              value={option}
              label="Subestado de gestión"
              variant="outlined"
              fullWidth
              onChange={(e) => setOption(e.target.value)}
              disabled={loading || !stateId}
            >
              {options.map((element: any) => {
                return (
                  <MenuItem key={element.id} value={element.id}>
                    {element.name}
                  </MenuItem>
                );
              })}
            </TextField>
          </Grid>
          {!completed && (
            <Grid item xs={6}>
              <TextField
                id="outlined-basic"
                label="Fecha gestión"
                variant="outlined"
                type="date"
                value={dueDate}
                fullWidth
                onChange={(e) => {
                  handleSetDate(e.target.value);
                }}
              />
            </Grid>
          )}
          <Grid item xs={!completed ? 6 : 12}>
            <TextField
              id="outlined-basic-two"
              label="Posible fecha de pago"
              variant="outlined"
              type="date"
              value={possiblePaymentDate}
              fullWidth
              onChange={(e) => {
                setPossiblePaymentDate(e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              error={checkFields && description === ''}
              id="outlined-basic"
              label="Observación"
              variant="outlined"
              fullWidth
              multiline
              disabled={disabled || !stateId || !option}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={completedCheckbox}
                  onChange={(e) => setCompletedCheckbox(e.target.checked)}
                  name="completed"
                  color="primary"
                />
              }
              label="Esta tarea ya fue completada?"
            />
          </Grid>
          {completedCheckbox && (
            <Grid item xs={12}>
              <TextField
                id="outlined-basic"
                label="Fecha de completado"
                variant="outlined"
                type="date"
                value={completedDate}
                fullWidth
                onChange={(e) => {
                  setCompletedDate(e.target.value);
                }}
              />
            </Grid>
          )}
        </Grid>
      )}
    </div>
  );
};

export default OptionsGrid;
